var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.element,{tag:"component",staticClass:"chip",class:{ chip__rounded: _vm.rounded }},[_vm._t("default"),(_vm.close)?_c('button',{staticClass:"chip--close",on:{"click":function($event){return _vm.$emit('close', $event)}}},[_c('Icon',{attrs:{"icon":"x-icon"}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }